import React, { useState, useEffect } from 'react';
import { ErrorFilled, WarningFilled } from '@one-thd/sui-icons';

import { Pagination } from '../../shared/pagination/Pagination';
import { DownloadsTable } from '../downloads-table/DownloadsTable';
import { DownloadTableSkeleton } from '../DownloadsSkeletons';

import { useDownloadsContext } from '../../../hooks/useContexts';

import { GetDownloadsList } from '../../../api/oms/downloads';
import { getSvocId } from '../../../utils/user';
import { getNumPages } from '../../../utils/general';

import {
  IOfflineDownloadListRequest,
  IOfflineDownloadListResponse,
} from '../../../models/downloads';

import '../../../styles/downloads.scss';

const failedDownloadMessage = () => (
  <div style={{ display: 'inline-flex', paddingBottom: 20 }}>
    <ErrorFilled color="warning" />
    <p style={{ color: '#8F6E2E', padding: '4px 0px 0px 10px' }}>
      <b>Download Failed</b>. Please reinitiate from your Linked Accounts page.
    </p>
  </div>
);

const noDownloadsMessage = () => (
  <div className="no-downloads-element">
    <WarningFilled color="warning" />
    <p>No Downloads Yet</p>
  </div>
);

const renderLinkedAccountDownloadsTable = (
  currentPage: number,
  setCurrentPage: (selectedPage: number) => void,
  downloadsData?: IOfflineDownloadListResponse,
) => {
  const memberCountInt = downloadsData?.fileList?.totalNumberOfRecords || 0;
  if (downloadsData && downloadsData.fileList.files.length > 0) {
    return (
      <>
        <DownloadsTable downloadType="OFFLINE" page={currentPage} />
        {Pagination({
          nPages: getNumPages(20, memberCountInt),
          page: currentPage,
          onChangePage: (selectedPage) => {
            setCurrentPage(selectedPage);
          },
        })}
      </>
    );
  }
  return noDownloadsMessage();
};

export const LinkedAccountDownloads = () => {
  const {
    downloadsData,
    downloadsError,
    downloadsLoaded,
    setDownloadsData,
    setDownloadsError,
    setDownloadsLoaded,
  } = useDownloadsContext();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const payload: IOfflineDownloadListRequest = {
      offlineCSVListRequest: {
        customerAccountId: getSvocId() || '',
        pageSize: 20,
        pageNumber: currentPage,
        listType: 'OFFLINE',
        filterCriteria: { fileName: '' },
      },
    };
    setDownloadsLoaded(false);
    GetDownloadsList(
      payload,
      setDownloadsData,
      setDownloadsError,
      setDownloadsLoaded,
    );
  }, [currentPage]);

  if (downloadsLoaded) {
    if (downloadsError) {
      return failedDownloadMessage();
    }

    return renderLinkedAccountDownloadsTable(
      currentPage,
      setCurrentPage,
      downloadsData,
    );
  }
  return <DownloadTableSkeleton />;
};
